import * as ActionTypes from '../ActionTypes';

const initialState = {
    isLoading: true,
    success: false,
    error: false,
    successMessage: "",
    errorMessage: "",
    leavereasonData: []
}

export const LeaveReasonReducer = function (state = initialState, action) {
    switch (action.type) {
        case ActionTypes.LEAVE_REASON_GET_REQUEST:
            return {
                ...state,
                isLoading: true,
                success: false,
                successMessage: "",
                error: false,
                errorMessage: "",
            };
        case ActionTypes.LEAVE_REASON_GET_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                successMessage: action.payload?.message,
                leavereasonData: action.payload?.data?.data
            };
        case ActionTypes.LEAVE_REASON_GET_ERROR:
            return {
                ...state,
                isLoading: false,
                error: true,
                success: false,
                errorMessage: action.payload?.data?.error?.[0]?.message
            }
        case ActionTypes.LEAVE_REASON_ADD_REQUEST:
            return {
                ...state,
                isLoading: true,
                success: false,
                error: false,
            };
        case ActionTypes.LEAVE_REASON_ADD_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                successMessage: action.payload?.message,
                leavereasonData: action.payload?.data?.data
            };
        case ActionTypes.LEAVE_REASON_ADD_ERROR:
            return {
                ...state,
                isLoading: false,
                error: true,
                success: false,
                errorMessage: action.payload?.data?.error?.[0]?.message
            }
        case ActionTypes.LEAVE_REASON_UPDATE_REQUEST:
            return {
                ...state,
                isLoading: true,
                success: false,
                error: false,
            };
        case ActionTypes.LEAVE_REASON_UPDATE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                successMessage: action.payload?.message,
                leavereasonData: action.payload?.data?.data
            };
        case ActionTypes.LEAVE_REASON_UPDATE_ERROR:
            return {
                ...state,
                isLoading: false,
                error: true,
                success: false,
                errorMessage: action.payload?.data?.error?.[0]?.message
            }
        case ActionTypes.LEAVE_REASON_DELETE_REQUEST:
            return {
                ...state,
                isLoading: true,
                success: false,
                error: false,
            };
        case ActionTypes.LEAVE_REASON_DELETE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                successMessage: action.payload?.message,
                leavereasonData: action.payload?.data?.data
            };
        case ActionTypes.LEAVE_REASON_DELETE_ERROR:
            return {
                ...state,
                isLoading: false,
                error: true,
                success: false,
                errorMessage: action.payload?.data?.error?.[0]?.message
            }
        default:
            return state;
    }
}